import React from 'react'
import { EmptyState, LoadingState } from '../../../shared/empty-state/empty-state'
import { ErrorReference } from '../../../shared/error/error-reference'
import { IconAnalytic } from '../../../shared/icon/icon'
import '../../../shared/sso-workspace/sso-workspace.scss'
import '../../../shared/sso-workspace/fleet.scss'

// What an LMS insights page says while it has no report to show.

export const UNAVAILABLE_TEXT = "LMS insights aren't available for this organization."

export const LmsInsightsUnavailable = () =>
  <EmptyState Icon={IconAnalytic} title={UNAVAILABLE_TEXT} testID="lms-insights-unavailable" />

// A failed read: plain words, the request's reference for support when it has
// one, and Try again. A refusal the service worded for people (a range it will
// not read) says that sentence.
export const ReportFailed = ({ subject, report }) =>
  <div className="sw-notice bad" role="alert" data-testid="lms-insights-error">
    <div>
      <p>{report.message || `Couldn't load ${subject}.`}</p>
      <ErrorReference error={report.error} className="mt-2" />
      <button type="button" className="btn btn-sm btn-outline-secondary mt-2" onClick={report.retry}>Try again</button>
    </div>
  </div>

// report is useLmsReports's answer. subject names what the page shows ("LMS
// launches"), empty is the sentence for a range with nothing in it (isEmpty
// says when that is), and children(data) draws the page once it has its data.
export const ReportStatus = ({ report, subject, empty, emptyHint, isEmpty, children }) => {
  if (report.status === 'loading') return <LoadingState rows={4} label={`Loading ${subject}`} />
  if (report.status === 'unavailable') return <LmsInsightsUnavailable />
  if (report.status === 'error') return <ReportFailed subject={subject} report={report} />
  if (isEmpty(report.data)) return <EmptyState Icon={IconAnalytic} title={empty} message={emptyHint} testID="lms-insights-empty" />
  return children(report.data)
}
